import { PHONEME_AUDIO_FILES } from '../../../learn/assets/audios/letters.ts';

import { getLettersUtil } from '../asset/letters.util.ts';

export class AudioLettersProviderUtil {
  private static _instance: AudioLettersProviderUtil;

  private constructor() {
    //
  }

  public static get instance(): AudioLettersProviderUtil {
    if (!AudioLettersProviderUtil._instance) {
      AudioLettersProviderUtil._instance = new AudioLettersProviderUtil();
    }
    return AudioLettersProviderUtil._instance;
  }

  public getLetter(letter: string): string {
    const letterFile = getLettersUtil().getLetter(letter)?.file;
    if (!letterFile) {
      return '';
    }
    const letterFileWithoutExtension = letterFile.split('.').slice(0, -1).join('.');
    const audioFile = PHONEME_AUDIO_FILES[letterFileWithoutExtension as keyof typeof PHONEME_AUDIO_FILES];
    return audioFile;
  }

  public async getLetterDuration(letter: string): Promise<number> {
    const audio = this.getLetter(letter);
    if (!audio) return 0;
    const audioContext = new AudioContext();
    const audioFile = await fetch(audio);
    if (!audioFile.ok) return 0;
    const arrayBuffer = await audioFile.arrayBuffer();
    const buffer = await audioContext.decodeAudioData(arrayBuffer);
    return buffer.duration;
  }
}

export const getAudioLettersProviderUtil = (): AudioLettersProviderUtil => AudioLettersProviderUtil.instance;
